export default __webpack_public_path__ + "cb0ec48fda7b39b9825a0efc3d5a2419.png";